import { User } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { ResourceHeaderProps } from "./CalendarEventTypes";

export function ResourceHeader({ label, resource }: ResourceHeaderProps) {
  const fallbackLabel = typeof label === "string" ? label : undefined;
  const displayName = resource?.full_name ?? fallbackLabel ?? "Profissional";
  const hasDisplayName = displayName.trim().length > 0;
  const role = (resource?.role ?? "").toLowerCase();
  const isVeterinarian = role.includes("veterin");
  const isGroomer = role.includes("groomer");
  const isUnassigned =
    resource?.id === "unassigned" || (hasDisplayName && displayName.toLowerCase().includes("sem profissional"));

  return (
    <div className="flex items-center justify-between gap-2 px-2 py-2">
      <div className="flex min-w-0 items-center gap-2">
        {hasDisplayName ? (
          <span className="min-w-0 truncate text-[12px] font-semibold text-foreground">{displayName}</span>
        ) : null}
      </div>
    </div>
  );
}
